const expirationList = [{
        value: 1,
        label: '1个月',
    },
    {
        value: 3,
        label: '3个月',
    },
    {
        value: 6,
        label: '6个月',
    }, {
        value: 12,
        label: '1年',
        discount: 8
    },
    {
        value: 24,
        label: '2年',
        discount: 7
    }, {
        value: 36,
        label: '3年',
        discount: 6
    }
]

const expirationObj = {
    1: '1个月',
    3: '3个月',
    6: '6个月',
    12: '1年',
    24: '2年',
    36: '3年'
}

const appInfo = {
    'QHD': {
        name: '趣互动',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/d95d4928086b48d0908c7a5eff7b19f1.png',
        tags: ["拉新裂变", "拉新裂变", "游戏化"],
    },
    'BEAUTY': {
        name: '医美会员',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/7b0160da4676410c8edf3b4b3a6648df.png',
        tags: ["拉新裂变", "拉新裂变", "游戏化"],
    },
    'QDG': {
        name: '趣导购',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/447ac8e8041243fba16c82db9e9354f1.png',
        tags: ["拉新裂变", "拉新裂变", "游戏化"],
    },
    'YGT': {
        name: '云柜台',
        icon: 'https://easystock.oss-cn-hangzhou.aliyuncs.com/13a34c148c204438a158f6e6c224c4b8.png',
        tags: ["拉新裂变", "拉新裂变", "游戏化"],
    }
}

const priceObj = {
    'development': 0.01,
    'test': 0.01,
    'production': 800
}

export {
    expirationList,
    expirationObj,
    appInfo,
    priceObj
}